import React from "react";
import PropTypes from "prop-types";
import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ items, label = "Breadcrumb" }) => (
  <nav aria-label={label} className="wsm-breadcrumbs">
    <ol>
      {items.map((item, index) => {
        const current = index === items.length - 1;
        return (
          <li key={item.label}>
            {index > 0 && <ChevronRight aria-hidden="true" />}
            {current ? <span aria-current="page">{item.label}</span> : <a href={item.href}>{item.label}</a>}
          </li>
        );
      })}
    </ol>
  </nav>
);

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ href: PropTypes.string, label: PropTypes.string.isRequired })).isRequired,
  label: PropTypes.string,
};

export default Breadcrumbs;
